import React, { ReactNode } from "react";
import "./LoginWrapper.scss";
import { isDesktop } from "../../utils";

interface LoginWrapperProps {
  children: ReactNode;
  className?: string;
}

const LoginWrapper: React.FC<LoginWrapperProps> = ({
  children,
  className = "",
}) => {
  return (
    <main className={`login-wrapper ${className}`}>
      <div className="login-wrapper__background-wrapper">
        {isDesktop() ? (
          <img
            src={require("../../assets/images/loginPageBg.webp")}
            className="login-wrapper__background"
            alt="Background"
          />
        ) : (
          <img
            src={require("../../assets/images/loginPageBgMobile.webp")}
            className="login-wrapper__background"
            alt="Background"
          />
        )}
      </div>
      <div className="login-wrapper__content">{children}</div>
    </main>
  );
};

export default LoginWrapper;
